import React, {
  useState,
  createContext,
  useEffect,
  useMemo,
  useCallback,
} from 'react';
import { useMedia } from '@monash/portal-react';

export const MenuContext = createContext();

const MenuProvider = ({ children }) => {
  const size = useMedia();
  const [menu, setMenu] = useState(false);
  const [menuRef, setMenuRef] = useState(null);

  const getMenuRef = (e) => {
    setMenuRef(e.current);
  };

  const handleMenu = useCallback(() => {
    setMenu(!menu);
  }, [menu]);

  const closeMenu = useCallback(() => {
    if (size !== 'L') {
      setMenu(false);
    }
  }, [size]);

  useEffect(() => {
    if (size === 'L') setMenu(false);
  }, [size]);

  const values = useMemo(
    () => ({
      menu,
      handleMenu,
      closeMenu,
      size,
      menuRef,
      getMenuRef,
    }),
    [menu, handleMenu, closeMenu, size, menuRef],
  );

  return <MenuContext.Provider value={values}>{children}</MenuContext.Provider>;
};

export default MenuProvider;
